import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import HavenSelection from "../Selection2/HavenSelection";
import DualEleganceSelection from "../Selection2/DualEleganceSelection";
import LightAndSpaceSelection from "../Selection2/LightAndSpaceSelection";
import IehouseSelection from "../Selection2/IehouseSelection";
import PrivateApartmentShow from "../InteriorDesignComponents/InteriorShow/PrivateApartmentShow";

export default function PrivateApartmentComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="../../Images/ResidentialImages/privateapartment/MODERN~12.jpg"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5"> Private Apartment</p>

              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>role in project: 3d visualization</span>
                <span>project duration: 2 weeks</span>
                <span>year of completion: 2024</span>
                <span>project location: The Pearl, Doha-QATAR</span>
              </div>
            </div>
          </div>
        </section>


        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "35px",
                  textTransform:"uppercase",
                  padding:"50px"
                }}
              >
              Neutral tones provide a calming foundation, complemented by deep
              blue featured in the bedroom and vanity areas.
              </h1>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>


        <section className="projects">
          <div className="img">
            <ParallaxImage
              src="../../Images/ResidentialImages/privateapartment/MODERN~22.jpg"
              alt=""
            />
          </div>



          {/* <div className="projects-brief">
              <p
                style={{
                    color:"black",
                    fontSize:"30px"
                }}
              >
              This modern living space and bedroom are designed to inspire with its elegant lines, warm tones, and luxurious finishes, creating an inviting ambiance for both relaxation and entertaining.
              </p>
            </div> */}

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                marginTop: "1000px",
                zIndex: "9999",
              }}
            >
              {/* <ParallaxImage
                src="../../Images/ResidentialImages/privateapartment/MODERN~22.jpg"
                alt=""
              /> */}
            </div>
          </div>

          <div className="col projects-list">
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
             Neutral  
                <br />
                tones
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
             accented
                <br />
                by
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
               blue and 
                <br />
                gold
              </h1>
            </div>
          </div>
        </section>

    

        <section className="about">
          <div className="col intro">
            <p>ABOUT</p>
            <p
              style={{
                width: "500px",
              }}
            >
              The project is a carefully designed interior for a modern
              apartment located in a tower in The Pearl, Qatar. The living areas
              are defined by their openness and bright ambiance with soft
              curtains and walls decorated with abstract metallic wall art.
              Neutral tones dominate the color palette, with hints of blue and
              gold adding a touch of style.
              <br />
              <br />
              The bedroom design follows a calm theme, with a soft blue-gray
              headboard complementing the light wood tones of the furniture.
              Decorative circular wall art adds texture and depth, while soft
              lighting enhances the peaceful atmosphere.
            </p>
          </div>
          <div className="col portrait">
            <div className="portrait-container">
              <div className="img">
                <ParallaxImage
                  src="../../Images/ResidentialImages/privateapartment/WOODBE~12.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>
        {/* 
        <section className="banner">
          <IehouseSelection />
        </section> */}

        <section className="banner">
          <div className="img">
            <ParallaxImage
              src="../../Images/ResidentialImages/privateapartment/modern22.jpg"
              alt=""
            />
          </div>

          {/* <div className="banner-copy">
              <p
              
              >Location:</p>
              <h1
                style={{
                    color:"#1a1a1a"
                }}
              >Yenimahalle, </h1>
             <h1
               style={{
                color:"#1a1a1a"
            }}
             >Ankara-TURKIYE</h1>
            
            </div> */}
        </section>

        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                  textTransform: "capitalize",
                }}
              >
               Calm bedroom with soft blue-gray tones.
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
<PrivateApartmentShow/>
        <InteriorDesignResidentialSelectionComponent />
      </div>
    </ReactLenis>
  );
}
